<template>
  <div></div>
</template>

<script>
import {
  Dialog,
} from 'vant';
import {
  getUserInfo
} from '../../utils/shareRequest'
import {
  closeCurrentPage
} from '../../utils/nativeOtherOperate.js';
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      const _appToken = this.$route.query._appToken
      if (_appToken) {
        window.localStorage.setItem("Identity_Token", _appToken)
        this.$store.commit("changeLoginToken", _appToken)
        this.$store.dispatch(this.$LoadShow, true)
        this.$store.dispatch(this.$LoadText, '登录中...')
        this.$get('/seal/api/genAppToken', {
          appCode: "ESIGN"
        }).then((res) => {
          this.$store.dispatch(this.$LoadShow, false)
          if (res.success && res.data) {
            this.logon(res.data)
          } else {
            this.$Toast(res.message || '获取token失败，请重试!')
            this.failExit(res.message)
          }
        }).catch((err) => {
          //console.log('catch--=', err)
          this.$Toast('获取token失败，请重试!')
          this.failExit('报错')
        }).finally(() => {
          this.$store.dispatch(this.$LoadShow, false)
        })
      } else {
        this.logon()
      }
    },
    logon(appToken = '') {
      //const appToken = this.$route.query.appToken //token值，有效期很短
      let redirectUrl = this.$route.query.redirectUrl //跳转地址
      console.log('redirectUrl', redirectUrl)
      const params = {
        token: appToken ? appToken : this.$route.query.appToken
      }
      if (!redirectUrl.includes('appCode')) {
        if (redirectUrl.includes('?')) {
          redirectUrl += '&appCode=single'
        } else {
          redirectUrl += '?appCode=single'
        }
      }
      this.$store.dispatch(this.$addSourceFlag, 'singleLogon')
      this.$store.dispatch(this.$LoadShow, true)
      this.$store.dispatch(this.$LoadText, '登录中...')
      this.$post('/login/api/tokenLogin', params).then(rel => {
        if (rel.success) {
          window.localStorage.setItem("LoginInfo", JSON.stringify(rel.data))
          window.localStorage.setItem("Identity_Token", rel.data.token)
          this.$store.commit("changeLoginToken", rel.data.token)
          this.$store.commit("changeLoginInfo", rel.data)
          this.$store.commit("changeReLogin", '1')
          getUserInfo()
          //console.log('redirectUrl', redirectUrl)
          this.$router.push({
            path: redirectUrl ? redirectUrl : rel.data && rel.data.homeUrl ?
              rel.data.homeUrl : '/index'
          })
        } else {
          this.$Toast(rel.message || '系统错误,请联系管理员')
          this.failExit(rel.message)
        }
      }).catch((err) => {
        this.failExit('报错')
      }).finally(() => {
        this.$store.dispatch(this.$LoadShow, false)
        this.$store.dispatch(this.$LoadText, '加载中...')
      })
    },
    failExit(message) {
      Dialog.alert({
        title: '提示',
        message: '进入当前功能模块失败，' + message + ',点击确定返回重试！',
        confirmButtonText: '确定',
        confirmButtonColor: '#0277FC'
      }).then(() => {
        closeCurrentPage(0)
      });
    }
  },
}
</script>

<style>
</style>